import {LocationDefinition} from "../../../../../providers/definitions/LocationDefinitionProvider";

export const emptyLocationDefinition: LocationDefinition = {
    id: "",
    title: "",
    description: "",
    phone: "",
    address: "",
    imageUrl: ""
};